"use strict";
(function () {
    const labelElement = document.querySelector('.spv-textarea--textlimit');
    const guid = labelElement?.dataset['guid'];
    const length = labelElement?.dataset['length'];
    if (guid && length) {
        const input = document.getElementById(guid);
        const display = document.getElementById(guid + '-counter');
        input?.addEventListener('keyup', e => {
            const { target } = e;
            if (target instanceof HTMLTextAreaElement) {
                display.innerHTML = `${Number(length) - target.value.length}`;
            }
        });
    }
})();
//# sourceMappingURL=counter.js.map